import ResetPasswordForm from './ResetPasswordForm'
import AccountNav from './AccountNav'

document.addEventListener('DOMContentLoaded', () => {
  ResetPasswordForm()
  AccountNav()
})